import React from "react"
import {
  type IconProps,
  iconColorCss,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"

const InfoBalloon = (props: IconProps) => (
  <svg
    className={props.className}
    css={[iconSizeCss(props.size), iconColorCss(props.color)]}
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.2188 5.58289C19.2186 5.37032 19.1341 5.16655 18.9838 5.01624C18.8335 4.86592 18.6297 4.78137 18.4171 4.78125H5.58289C5.37032 4.78137 5.16655 4.86592 5.01624 5.01624C4.86592 5.16655 4.78137 5.37032 4.78125 5.58289V17.7605L6.68799 15.8538L6.84509 15.7249C7.01314 15.613 7.21224 15.5516 7.41711 15.5516H18.4171C18.6297 15.5515 18.8335 15.467 18.9838 15.3167C19.134 15.1663 19.2188 14.9626 19.2188 14.75V5.58289ZM21.2812 14.75C21.2812 15.5096 20.9791 16.2377 20.442 16.7749C19.9049 17.312 19.1767 17.614 18.4171 17.6141H7.84412L4.47913 20.9791C4.18422 21.274 3.74055 21.3629 3.35522 21.2034C2.96987 21.0438 2.71875 20.6671 2.71875 20.25V5.58289C2.71887 4.82331 3.02088 4.09509 3.55798 3.55798C4.09509 3.02088 4.82331 2.71887 5.58289 2.71875H18.4171C19.1767 2.71887 19.9049 3.02088 20.442 3.55798C20.9791 4.09509 21.2811 4.82331 21.2812 5.58289V14.75Z"
      fill="var(--color)"
    />
    <path
      d="M12.0067 12.257C12.5763 12.257 13.038 12.7187 13.038 13.2882C13.038 13.8578 12.5763 14.3195 12.0067 14.3195H12C11.4305 14.3195 10.9688 13.8578 10.9688 13.2882C10.9688 12.7187 11.4305 12.257 12 12.257H12.0067Z"
      fill="var(--color)"
    />
    <path
      d="M12.0034 7.17651V10.2888"
      stroke="var(--color)"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
)

export default InfoBalloon
